import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import WinnerDropBadge from "../drops/winner/WinnerDropBadge";
interface WinnerBadgeProps {
  readonly drop: ApiDrop;
  readonly showBadge?: boolean | undefined;
  readonly variant?: "default" | "simple" | undefined;
}
export const WinnerBadge: React.FC<WinnerBadgeProps> = t0 => {
  const $ = _c(4);
  const {
    drop,
    showBadge: t1,
    variant: t2
  } = t0;
  const showBadge = t1 === undefined ? true : t1;
  const variant = t2 === undefined ? "default" : t2;
  const {
    winningRank
  } = useDropInteractionRules(drop);
  const winningTime = drop.winning_context?.decision_time || null;
  if (!winningRank || !showBadge) {
    return null;
  }
  let t3;
  if ($[0] !== variant || $[1] !== winningRank || $[2] !== winningTime) {
    t3 = <div className="tw-flex"><WinnerDropBadge rank={winningRank} decisionTime={winningTime} variant={variant} /></div>;
    $[0] = variant;
    $[1] = winningRank;
    $[2] = winningTime;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};